import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: 15px;\n    cursor: pointer;\n    box-shadow: 0 0 0px 1px #ccc7c7 !important;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 10px;\n    background: none;\n    box-shadow: none;\n    :hover {\n        box-shadow: none;\n    }\n    > i {\n        display: flex;\n        justify-content: flex-end;\n        color: ", ";\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            & > ", " {\n                position: fixed;\n                top: 0;\n                left: 0;\n                right: 0;\n                bottom: 0;\n            }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        position: relative;\n        user-select: none;\n        width: ", ";\n\n        ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Popover } from '../../Atoms';
import { RawInput } from '../../Atoms/InputText';
export var StyledInputCalendar = styled.div(_templateObject(), function (props) {
  return css(_templateObject2(), props.fullWidth ? '100%' : 'auto', media.max.md(_templateObject3(), Popover.Styles.StyledPopover));
});
export var StyledPopover = styled(Popover)(_templateObject4(), function (props) {
  return props.theme.components.dateRange.controllerColor;
});
export var StyledRawInput = styled(RawInput)(_templateObject5(), function (props) {
  return props.theme.global.typographyConfig.body.fontFamily;
});